export enum ReportTemplateType {
  HumanResourcesAggregatedSummary = "hr.template.aggregatedSummary",
  HumanResourcesEmploymentCertificate = "hr.template.employmentCertificate",
  HumanResourcesTimesheets = "hr.template.timesheets",
  HumanResourcesLeaves = "hr.template.leaves",
}
